<template>
    <div class="py-8 px-6">
        <ViewTransactionsHeader @sell-item="sellItem" @go-to-new-event="goToNewEvent"
            @detailed-report-dialog="detailedReportDialog = true" @add-new-expense="addNewExpense"
            :disabledActions="loading && !stripeReady" />

        <div v-if="loading && !stripeReady" class="text-center">
            <h3 class="gray--text">{{ $t('message.transactions_admin_plus.checking_connection') }}...</h3>
        </div>

        <div v-else>
            <div>
                <PaymentConnectionAlert :loading="loading" :paymentsReady="paymentsReady"
                    :stripeReady="stripeReady || false" :paymentsModule="paymentsModule || ''"
                    @show-connect-dialog="connectPaymentDialog = true" @connect-payments="connectPayments()" />

                <!-- <v-card-actions v-if="!isSmallerDisplay()">
                    <v-spacer></v-spacer>
                    <v-btn outlined elevation="0" small color="primary" @click="sellItem()">
                        <v-icon class="mr-1">mdi-cart-outline</v-icon>
                        <span>{{ $t("message.transactions_admin_plus.sell_item") }}</span>
                    </v-btn>
                    <v-btn outlined elevation="0" small color="primary" @click="goToNewEvent()">
                        <v-icon class="mr-1">mdi-calendar</v-icon>
                        <span>{{ $t("message.transactions_admin_plus.create_event") }}</span>
                    </v-btn>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="stripeReady" class="ml-1" v-bind="attrs" v-on="on" elevation="0" small
                                color="secondary" @click="goToStripeSupport()">
                                <v-icon class="mr-1">mdi-lifebuoy</v-icon>
                                <span>{{ $t("message.transactions_admin_plus.stripe_support") }}</span>
                            </v-btn>
                        </template>
<span>{{ $t('message.transactions_admin_plus.transaction_problems') }}</span>
</v-tooltip>
<v-btn class="ml-1" v-if="!isSmallerDisplay()" small :disabled="downloadingAllTransactions" color="secondary"
    elevation="0" @click="detailedReportDialog = true">
    <v-progress-circular small indeterminate color="white" v-if="downloadingAllTransactions">
    </v-progress-circular>
    <v-icon class="mr-1">mdi-cloud-download-outline</v-icon>
    {{ $t('message.transactions_admin_plus.report') }}
</v-btn>
</v-card-actions>
<v-card-actions v-else>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
                            <v-btn outlined color="primary" elevation="0" v-on="on" block small slot="activator" left>
                                {{ $t('message.transactions_admin_plus.actions') }}
                            </v-btn>
                        </template>
        <v-list>
            <v-list-item @click.stop="sellItem()">
                <v-list-item-title>
                    <v-icon class="mr-1">mdi-cart-outline</v-icon>
                    <span>{{ $t("message.transactions_admin_plus.sell_item") }}</span>
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToNewEvent()">
                <v-list-item-title>
                    <v-icon class="mr-1">mdi-calendar</v-icon>
                    <span>{{ $t("message.transactions_admin_plus.create_event") }}</span>
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToStripeSupport()">
                <v-list-item-title>
                    <v-icon class="mr-1">mdi-lifebuoy</v-icon>
                    <span>{{ $t("message.transactions_admin_plus.stripe_support") }}</span>
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="detailedReportDialog = true">
                <v-list-item-title>
                    <v-progress-circular small indeterminate color="white" v-if="downloadingAllTransactions">
                    </v-progress-circular>
                    <v-icon class="mr-1">mdi-cloud-download-outline</v-icon>
                    {{ $t('message.transactions_admin_plus.report') }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</v-card-actions> -->
                <v-tabs show-arrows v-model="activeTab" slider-color="plusIndigoDarken1" color="plusTabActiveText"
                    class="mt-6 font-roboto">
                    <v-tab :key="'dashboard'" @click="clickTab(0)" ripple
                        class="d-flex align-center font-roboto font-weight-medium text-body-2">
                        {{ $t('message.transactions_admin_plus.financial_overview') }}
                    </v-tab>
                    <v-tab @click="clickTab(1)" :key="'revenue'" ripple
                        class="d-flex align-center font-roboto font-weight-medium text-body-2">
                        {{ $t('message.transactions_admin_plus.revenue_tab') }}
                    </v-tab>
                    <v-tab v-show="stripeReady" :key="'invoices'" @click="clickTab(2)" ripple
                        class="d-flex align-center font-roboto font-weight-medium text-body-2">
                        {{ $t('message.transactions_admin_plus.credit_card_invoices') }}</v-tab>
                    <v-tab :key="'expenses'" @click="clickTab(3)" ripple
                        class="d-flex align-center font-roboto font-weight-medium text-body-2">{{
                            $t('message.transactions_admin_plus.expenses')
                        }}</v-tab>

                    <v-tabs-items v-model="activeTab" class="mt-6">
                        <v-tab-item :key="'aggregates'">
                            <FinancialOverview :academy="academy" :currency-symbol="currencySymbol"
                                :loading-current-month-income="loadingCurrentMonthIncome"
                                :chart-data-income-monthly="chartDataIncomeMonthly"
                                :chart-options-income-monthly="chartOptionsIncomeMonthly"
                                :current-month-total="currentMonthTotal" :payouts-history="payoutsHistory"
                                :triggering-refresh="triggeringRefresh" :loading-bottom-charts="loadingBottomCharts"
                                :selected-income-graph-months="selectedIncomeGraphMonths"
                                :available-months="availableMonths" :income-bar-quarterly="incomeBarQuarterly"
                                :income-bars="incomeBars" :products-graph="productsGraph"
                                :pie-chart-selection="pieChartSelection"
                                :loading-income-trendline="loadingIncomeTrendline" :income-trendline="incomeTrendline"
                                :stripe-ready="stripeReady" :revenue-donut-chart-data="revenueDonutChartData"
                                :revenue-donut-chart-options="revenueDonutChartOptions"
                                :loading-revenue-donut-chart="loadingRevenueDonutChart"
                                :expense-donut-chart-data="expenseDonutChartData"
                                :expense-donut-chart-options="expenseDonutChartOptions"
                                :loading-expense-donut-chart="loadingExpenseDonutChart"
                                :selected-products-graph-months="selectedProductsGraphMonths"
                                @trigger-stats-refresh="triggerStatsRefresh" @filter-dated-income="filterDatedIncome"
                                @build-income-bars="buildIncomeBars"
                                @close-pie-chart-selection="pieChartSelection = null"
                                @update:selected-income-graph-months="onUpdateSelectedIncomeGraphMonths"
                                @update:selected-products-graph-months="onUpdateSelectedProductsGraphMonths"
                                @quarterly-changed="onQuarterlyChanged" />
                        </v-tab-item>

                        <v-tab-item :key="'revenue'">
                            <ViewRevenue :academy="academy" :loading-revenue="loadingRevenue"
                                :stripe-ready="stripeReady" :revenue-filtered="revenueFiltered"
                                :revenue-type-filter="revenueTypeFilter" :revenue-status-filter="revenueStatusFilter"
                                :subscriptions-filter="subscriptionsFilter" :pending-filter="pendingFilter"
                                :revenue-user-filter="revenueUserFilter" :revenue-product-filter="revenueProductFilter"
                                :subscription-tag-filter="subscriptionTagFilter" :all-products="allProducts"
                                :membership-products="membershipProducts" :available-tags="availableTags"
                                :from-filter="fromFilter" :to-filter="toFilter"
                                :total-count-title="revenueTotalCountTitle"
                                :total-amount-title="revenueTotalAmountTitle" :total-revenue-amount="revenueTotalAmount"
                                :total-amount-tooltip="revenueTotalAmountTooltip" :currency-symbol="currencySymbol"
                                :monthly-total-revenue="revenueTotalMonthlyTotal"
                                :monthly-recurring-revenue="revenueTotalMRR"
                                :one-time-revenue-amount="revenueTotalOneTimeAmount"
                                :one-time-revenue-count="revenueTotalOneTimeCount"
                                :pending-payments-amount="revenueTotalPendingAmount"
                                :pending-payments-count="revenueTotalPendingCount"
                                :products-result-by-graph="productsResultByGraph"
                                :loading-product-timeline="loadingProductTimeline"
                                :product-timeline-graph="productTimelineGraph"
                                :downloading-memberships-table="downloadingMembershipsTable"
                                :memberships-trendline="membershipsTrendline"
                                :memberships-trendline-toggle="membershipsTrendlineToggle"
                                :loading-memberships-table="loadingMembershipsTable"
                                :cancelled-filtered="cancelledFiltered"
                                :loading-cancelled-subscriptions="loadingCancelledSubscriptions"
                                :revenue-headers="revenueHeaders" :revenue-headers-mobile="revenueHeadersMobile"
                                :get-status-color-for-item="getStatusColorForRevenueItem"
                                :get-status-text-for-item="getStatusTextForRevenueItem"
                                :get-amount-for-item="getAmountForRevenueItem" @filter-revenue="filterRevenue"
                                @get-recurrent-transactions="getRecurrentTransactions"
                                @download-memberships-table="downloadMembershipsTable"
                                @toggle-memberships-trendline="membershipsTrendlineToggle = !membershipsTrendlineToggle"
                                @toggle-products-result-by-graph="productsResultByGraph = !productsResultByGraph"
                                @get-product-timeline="getProductTimline"
                                @navigate-to-transaction="navigateTo({ name: 'viewtransaction', params: { sessionId: $event } })"
                                @navigate-to-revenue-item="navigateToRevenueItem"
                                @get-cancelled-subcriptions="getCancelledSubcriptions"
                                @update:revenue-type-filter="revenueTypeFilter = $event"
                                @update:revenue-status-filter="revenueStatusFilter = $event"
                                @update:subscriptions-filter="subscriptionsFilter = $event"
                                @update:pending-filter="pendingFilter = $event"
                                @update:revenue-user-filter="revenueUserFilter = $event"
                                @update:revenue-product-filter="revenueProductFilter = $event"
                                @update:subscription-tag-filter="subscriptionTagFilter = $event"
                                @update:from-filter="fromFilter = $event" @update:to-filter="toFilter = $event"
                                @user-img="userImg" @assets="assets" />
                        </v-tab-item>

                        <v-tab-item :key="'invoices'">
                            <ViewInvoices :academy="academy" :from-filter="fromFilter" :to-filter="toFilter"
                                :customers="customers" :customer-filter="customerFilter" :stripe-ready="stripeReady"
                                :payments-module="paymentsModule" :payments-ready="paymentsReady"
                                :loading-invoices="loadingInvoices" :invoices-total="invoicesTotal" :invoices="invoices"
                                :currency-symbol="currencySymbol" :refund-confirm-dialog="refundConfirmDialog"
                                :selected-invoice="selectedInvoice" :refund-amount="refundAmount"
                                @filter-invoices="filterInvoices" @view-invoice-transaction="viewInvoiceTransaction"
                                @show-refund-dialog="showRefundDialog" @refund="refund"
                                @close-refund-dialog="refundConfirmDialog = false"
                                @update:from-filter="fromFilter = $event" @update:to-filter="toFilter = $event"
                                @update:customer-filter="customerFilter = $event"
                                @update:refund-amount="refundAmount = $event" />
                        </v-tab-item>

                        <v-tab-item :key="'expenses'">
                            <ViewExpenses :academy="academy" :expenses-graphs="expensesGraphs"
                                :expenses-graph-range="expensesGraphRange" :expenses-tag-filter="expensesTagFilter"
                                :expense-tags="expenseTags" :from-filter="fromFilter" :to-filter="toFilter"
                                :loading-expenses="loadingExpenses" :expenses="expenses"
                                :expenses-filtered="expensesFiltered" :currency-symbol="currencySymbol"
                                @add-new-expense="addNewExpense" @get-expenses="getExpenses"
                                @go-to-expense="goToExpense" @update:expenses-graph-range="onUpdateExpensesGraphRange"
                                @update:expenses-tag-filter="onUpdateExpensesTagFilter"
                                @update:from-filter="onUpdateExpensesFromFilter"
                                @update:to-filter="onUpdateExpensesToFilter" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </div>
        </div>

        <!-- Global dialogs -->
        <v-dialog v-model="detailedReportDialog" max-width="90%">
            <v-card style class="text-xs-left pa-3">
                <v-card-title>
                    {{ $t('message.transactions_admin_plus.download_report') }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-switch hide-details v-model="byDatesReport"
                                :label="$t('message.transactions_admin_plus.dates')"></v-switch>
                        </v-col>
                    </v-row>
                    <div v-if="!byDatesReport" class="pa-1">
                        <v-select outlined dense v-model="monthAmount" :items="availableMonths" hide-details
                            :label="$t('message.transactions_admin_plus.months')"></v-select>
                    </div>
                    <div v-else class="pa-1">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <div class="text-subtitle-2">
                                    {{ $t('message.transactions_admin_plus.from') }}:
                                </div>
                                <div>
                                    <DatePicker :show-time="false" v-model="fromFilter" :past-event="true">
                                    </DatePicker>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <div class="text-subtitle-2">
                                    {{ $t('message.transactions_admin_plus.to') }}:
                                </div>
                                <div>
                                    <DatePicker :show-time="false" v-model="toFilter" :past-event="true">
                                    </DatePicker>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <v-switch hide-details :disabled="expensesOnly || membershipsOnly ? true : false"
                        v-model="retailOnly" :label="$t('message.transactions_admin_plus.retail_only')"></v-switch>
                    <v-switch hide-details :disabled="retailOnly || membershipsOnly ? true : false"
                        v-model="expensesOnly" :label="$t('message.transactions_admin_plus.expenses_only')"></v-switch>
                    <v-switch hide-details :disabled="retailOnly || expensesOnly ? true : false"
                        v-model="membershipsOnly"
                        :label="$t('message.transactions_admin_plus.memberships_only')"></v-switch>
                    <v-switch hide-details v-model="groupByMonth" :disabled="groupByCategory ? true : false"
                        :label="$t('message.transactions_admin_plus.group_by_month')"></v-switch>
                    <v-switch hide-details :disabled="groupByMonth ? true : false" v-model="groupByCategory"
                        :label="$t('message.transactions_admin_plus.group_by_category')"></v-switch>
                    <v-alert class="mt-1" v-if="groupByCategory" type="info">{{
                        $t('message.transactions_admin_plus.group_by_category_explained')
                        }}</v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="0" @click="detailedReportDialog = false">{{
                        $t('message.transactions_admin_plus.cancel')
                        }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined elevation="0" color="primary" @click="downloadAllTransactions()">{{ groupByCategory
                        ||
                        groupByMonth ? $t('message.transactions_admin_plus.aggregated') :
                        $t('message.transactions_admin_plus.detailed') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="connectPaymentDialog" max-width="600">
            <v-card style class="pa-3" outlined>
                <v-card-text class="text-h5 text-center">
                    {{ $t('message.transactions_admin_plus.payments_soon') }}
                </v-card-text>
                <v-card-text v-if="paymentsModule == 'infinicept'" class="text-center mt-1">
                    <div v-html="$t('message.transactions_admin_plus.partnering_infinicept')"></div>
                    <div class="text-center mt-2">
                        <img width="200px" :src="assets('logos/launchpay-logo.png')" />
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <div v-html="$t('message.partnering_stripe')"></div>
                </v-card-text>
                <v-card-actions>
                    <v-btn small elevation="0" @click="connectPaymentDialog = false">
                        {{ $t('message.transactions_admin_plus.close') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined small elevation="0" color="primary" @click="learnMore()">
                        {{ $t('message.transactions_admin_plus.know_more') }}
                    </v-btn>
                    <v-btn outlined small elevation="0"
                        v-if="paymentsModule == 'infinicept' && stripe_state && !stripeReady" color="primary"
                        @click="navigateTo({ name: 'onboarding-infinicept' })" style="margin-left:5px">
                        {{ $t('message.transactions_admin_plus.connect_payments') }}
                    </v-btn>
                    <v-btn outlined small elevation="0" v-else-if="!isSmallerDisplay() && stripe_state && !stripeReady"
                        color="primary" @click="connectPayments()" style="margin-left:5px">
                        {{ $t('message.transactions_admin_plus.connect_payments') }}
                    </v-btn>
                </v-card-actions>
                <v-card-text class="text-center text-caption" v-if="paymentsModule != 'infinicept'">
                    *{{ $t('message.transactions_admin_plus.connecting_payments_agreement') }}
                </v-card-text>
                <v-card-text v-if="isSmallerDisplay()" class="text-center text-caption error--text">
                    {{ $t('message.transactions_admin_plus.desktop_to_connect_payments') }}
                </v-card-text>
            </v-card>
        </v-dialog>
        <CustomOnboarding ref="transactionsAdminPlusTour" tour-name="transactions-adminplus-onboarding"
            :steps="transactionsAdminPlusTourSteps" :finish-route="null" finish-button-text="GOT IT" />
    </div>
</template>

<script>
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import CustomOnboarding from "@/components/onboarding/CustomOnboarding.vue";
import { buildTransactionsAdminPlusTourSteps } from "@/components/onboarding/transactionsAdminPlusTourSteps";
import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import { Environment } from "@/services/Environment";
import { completeOnboardingStep } from "@/services/onboardingSteps";
import PaymentConnectionAlert from "../../components/plus/transactions/PaymentConnectionAlert.vue";
import ViewTransactionsHeader from "../../components/plus/transactions/ViewTransactionsHeader.vue";
import FinancialOverview from "./FinancialOverview.vue";
import ViewExpenses from "./ViewExpenses.vue";
import ViewInvoices from "./ViewInvoices.vue";
import ViewRevenue from "./ViewRevenue.vue";

export default {
    name: "ViewTransactionsAdminPlus",
    components: {
        DatePicker,
        FinancialOverview,
        ViewRevenue,
        ViewInvoices,
        ViewExpenses,
        ViewTransactionsHeader,
        PaymentConnectionAlert,
        CustomOnboarding,
    },
    data() {
        return {
            state: this.$route.query.state,
            scope: this.$route.query.scope,
            code: this.$route.query.code,
            sessionId: this.$route.query.s,
            sessionStatus: this.$route.query.status,
            urlTab: this.$route.params.tabId,
            loading: false,
            academy: null,
            paymentsReady: false,
            productsResultByGraph: false,
            incomeBarQuarterly: false,
            byDatesReport: false,
            transactions: [],
            transactionsCompleted: [],
            transactionsPending: [],
            subscriptions: [],
            transactionsFiltered: [],
            expensesFiltered: [],
            expensesGraphs: { ready: false, thisMonth: {}, thisYear: {}, colors: [], selectedRange: { ready: false, options: {}, data: [] } },
            productsGraph: { ready: false, thisYear: {} },
            subscriptionsFiltered: [],
            paymentsModule: null,
            subscriptionsFilters: [],
            connectPaymentDialog: false,
            retailOnly: false,
            expensesOnly: false,
            membershipsOnly: false,
            detailedReportDialog: null,
            groupByCategory: false,
            loadingMembershipsTable: false,
            groupByMonth: false,
            cancelledFiltered: [],
            stripe_client_id: Environment.get("VUE_APP_STRIPE_CLIENT_ID"),
            stripe_state: null,
            currency: null,
            userFilter: null,
            monthAmount: 12,
            availableMonths: [
                { text: '6 months', value: 6 },
                { text: 'Yearly', value: 12 },
                { text: '18 months', value: 18 },
                { text: '24 months', value: 24 },
                { text: '30 months', value: 30 },
                { text: '36 months', value: 36 }
            ],
            adminFilter: null,
            productFilter: null,
            pendingFilter: null,
            fromFilter: null,
            toFilter: null,
            totalAmountTitle: this.$t('message.transactions_admin_plus.total_recurrent_income'),
            totalCountTitle: this.$t('message.transactions_admin_plus.total_recurrent_memberships'),
            customerFilter: null,
            currencySymbol: '$',
            activeTab: 0,
            expensesTagFilter: null,
            expensesGraphRange: 'thismonth',
            expenseTags: [],
            subscriptionUserFilter: null,
            subscriptionProductFilter: null,
            subscriptionTagFilter: null,
            revenueFiltered: [],
            revenueTypeFilter: 'subscriptions',
            revenueStatusFilter: 'all',
            revenueUserFilter: null,
            revenueProductFilter: null,
            selectedInvoice: null,
            refundConfirmDialog: false,
            selectedEndMonth: null,
            loadingProductTimeline: false,
            selectedStartMonth: null,
            customerSince: null,
            loadingBottomCharts: false,
            refundAmount: null,
            currentMonthTotal: 0,
            selectedIncomeGraphMonths: 12,
            selectedProductsGraphMonths: 12,
            productTimelineGraph: null,
            availableTags: [],
            admins: [],
            members: [],
            products: [],
            membershipProducts: [],
            invoices: [],
            expenses: [],
            loadingCurrentMonthIncome: false,
            loadingExpenses: false,
            payoutsHistory: {
                loading: true,
                headers: [],
                data: []
            },
            invoicesTotal: 0,
            pieChartSelection: null,
            today: null,
            loadingOneTimeTransactions: false,
            loadingCancelledSubscriptions: false,
            downloadingAllTransactions: false,
            stripeReady: false,
            loadingInvoices: true,
            loadingIncomeTrendline: false,
            triggeringRefresh: false,
            customers: null,
            chartOptionsIncomeMonthly: {},
            chartOptionsIncomeLastTwo: {},
            incomeTrendline: null,
            incomeBars: null,
            subscriptionsFilter: null,
            // Revenue Donut chart data
            revenueDonutChartData: [],
            revenueDonutChartOptions: {},
            loadingRevenueDonutChart: false,
            // Expense Donut chart data
            expenseDonutChartData: [],
            expenseDonutChartOptions: {},
            loadingExpenseDonutChart: false,
            totalRecurrentIncome: 0,
            downloadingMembershipsTable: false,
            subscriptionsHeaders: [
                { text: this.$t("message.transactions_admin_plus.sold_to"), value: "buyer" },
                { text: this.$t("message.transactions_admin_plus.subscription"), value: "productName" },
                { text: this.$t("message.transactions_admin_plus.sale_date"), value: "time" },
                { text: this.$t("message.transactions_admin_plus.frequency"), value: "productInterval" },
                { text: this.$t("message.transactions_admin_plus.billing_day"), value: "displayDate" },
                { text: this.$t("message.transactions_admin_plus.status"), value: "lastPaymentStatus" },
                { text: this.$t("message.transactions_admin_plus.price"), value: "amount" },
            ],
            transactionsHeaders: [
                { text: "", value: "processedBy" },
                { text: this.$t("message.transactions_admin_plus.sold_to"), value: "buyer" },
                { text: this.$t("message.transactions_admin_plus.items"), value: "items" },
                { text: this.$t("message.transactions_admin_plus.date"), value: "time" },
                { text: this.$t("message.transactions_admin_plus.status"), value: "completed" },
                { text: this.$t("message.transactions_admin_plus.price"), value: "amount" },
            ],
            revenueHeadersMobile: [
                { text: "", value: "avatar", sortable: true },
                { text: "Name", value: "buyerMobile" },
                { text: "Status", value: "statusMobile", align: "center" },
            ],
            membershipsTrendlineToggle: false,
            chartDataIncomeMonthly: false,
            membershipsTrendline: {
                options: {},
                data: [],
                membershipCounts: {},
                categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
            }
        };
    },
    mounted() {
        if (this.urlTab)
            this.selectTab(this.urlTab);

        if (!this.$store.state.managedAcademy) {
            this.navigateTo({ name: "noacademy" });
            return;
        }
        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        this.today = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);
        Api2()
            .get("admins/academy/" + this.$store.state.selectedAcademy)
            .then((response) => {
                this.academy = response.data;
                this.currency = this.academy.currency;
                this.paymentsModule = response.data.paymentsModule;
                this.currencySymbol = this.academy.currencySymbol;
                this.customerSince = response.data.customerSince;
                let monthsBetween = this.monthsBetween(new Date(), this.customerSince);
                if (monthsBetween > 1) {
                    if (monthsBetween > 30)
                        monthsBetween = 36;
                    this.availableMonths = [];
                    for (let i = 1; i < monthsBetween + 1; i++) {
                        this.availableMonths.push({
                            text: i + ' month' + (i > 1 ? 's' : ''),
                            value: i
                        });
                    }
                }
                if (this.urlTab == 3) {
                    // selectedRange's colors are looked up from expensesGraphs.colors, which
                    // the no-arg call below builds - it must finish first or every category
                    // falls back to the same default color.
                    this.loadExpensesCharts().then(() => {
                        this.loadExpensesCharts(this.expensesGraphRange);
                    });
                    this.getExpenses();
                } else if (this.urlTab == 0 || !this.urlTab) {
                    this.loadProductsCharts();
                    this.loadExpensesCharts(); // Load expense data for donut chart
                }
                Api2()
                    .get(
                        "admins/academy/" +
                        this.$store.state.managedAcademy +
                        "/is_connected/stripe"
                    )
                    .then((response) => {
                        this.stripe_state = response.data.stripeState;
                        if (this.paymentsModule == 'infinicept')
                            this.stripe_state = 'Infini';
                        this.stripeReady = response.data.stripeConnected;
                        this.paymentsReady = response.data.paymentsReady;
                        this.checkRedirected();
                        if (this.stripeReady) {
                            this.$store.dispatch("setStripeAccountId", response.data.id);
                            if (this.sessionStatus == "success") {
                                //Push completed
                                if (this.sessionId) {
                                    this.completePurchase(this.sessionId);
                                } else {
                                    this.showAlert(
                                        "success",
                                        this.$t("message.transactions_admin_plus.payment_completed")
                                    );
                                }
                            } else if (this.sessionId && this.sessionStatus == "cancel") {
                                this.cancelPurchase(this.sessionId);
                            }
                        } else {
                            this.loading = false;
                        }
                        this.getTransactions();
                        this.getBalances();
                    });
            });
        Api2()
            .get("admins/academy/" + this.$store.state.selectedAcademy + "/members")
            .then((response) => {
                const data = response.data;
                if (data) {
                    for (const m of data.approved) {
                        this.members.push({ value: m._id, text: m.fName + " " + m.lName });
                    }
                }
            })
            .catch((e) => {
                if (e)
                    this.showAlert(
                        "error",
                        "Oops!",
                        "Looks like you should not be here."
                    );
            });
        this.getCustomers();
        this.getProducts();
        if (this.isSmallerDisplay()) {
            this.subscriptionsFilters = [
                {
                    text: this.$t('message.transactions_admin_plus.all'),
                    value: null
                },
                {
                    text: this.$t('message.transactions_admin_plus.good_standing'),
                    value: 'active'
                },
                {
                    text: this.$t('message.transactions_admin_plus.past_due'),
                    value: 'past_due'
                },
                {
                    text: this.$t('message.transactions_admin_plus.waiting_to_start'),
                    value: 'waiting2start'
                },
                {
                    text: this.$t('message.transactions_admin_plus.pending_payment'),
                    value: 'pending'
                },
                {
                    text: this.$t('message.transactions_admin_plus.paused'),
                    value: 'paused'
                },
                {
                    text: this.$t('message.transactions_admin_plus.show_manual_only'),
                    value: 'manual'
                },
                {
                    text: this.$t('message.transactions_admin_plus.expiring_soon'),
                    value: 'expiring_soon'
                },
                {
                    text: this.$t('message.transactions_admin_plus.expired'),
                    value: 'expired'
                },
                {
                    text: this.$t('message.transactions_admin_plus.scheduled_cancellation'),
                    value: 'scheduled_cancellation'
                },
                {
                    text: this.$t('message.transactions_admin_plus.scheduled_pause'),
                    value: 'scheduled_pause'
                }
            ];
        }
        this.tryStartTransactionsAdminPlusTour();
    },
    computed: {
        transactionsAdminPlusTourSteps() {
            return buildTransactionsAdminPlusTourSteps(this);
        },
        loadingRevenue() {
            return this.loading || this.loadingOneTimeTransactions;
        },
        allProducts() {
            const seen = new Set();
            const result = [];
            for (const p of this.membershipProducts || []) {
                if (p.value && !seen.has(p.value)) { seen.add(p.value); result.push(p); }
            }
            for (const p of this.products || []) {
                if (p.value && !seen.has(p.value)) { seen.add(p.value); result.push(p); }
            }
            return result;
        },
        revenueTotalCountTitle() {
            if (this.revenueTypeFilter === 'onetime') return this.$t('message.transactions_admin_plus.one_time_purchases');
            return this.totalCountTitle;
        },
        revenueTotalAmountTitle() {
            if (this.revenueTypeFilter === 'onetime') return this.$t('message.transactions_admin_plus.price');
            return this.totalAmountTitle;
        },
        revenueTotalSubscriptions() {
            if (this.revenueTypeFilter === 'subscriptions') return this.totalCountTitle + ": " + this.totalRecurrentIncome;
            return '';
        },
        revenueTotalAmountTooltip() {
            if (this.revenueTypeFilter === 'subscriptions') return this.$t('message.transactions_admin_plus.calculated_monthly_basis');
            return '';
        },
        revenueTotalMRR() {
            // Disabled — iterates all subscriptions, hidden in UI
            return (0).toFixed(2);
            /* let total = 0;
            for (const t of this.subscriptions || []) {
                const amount = parseFloat(this.getMembershipTotal(t)) || 0;
                const interval = t.product ? t.product.interval : null;
                let monthly = amount;
                if (interval === 'bi-week') monthly = amount * 2;
                else if (interval === 'week') monthly = amount * 4;
                else if (interval === 'bi-year') monthly = amount / 6;
                else if (interval === 'year') monthly = amount / 12;
                else if (interval === 'day') monthly = amount * 30;
                total += monthly;
            }
            return total.toFixed(2); */
        },
        revenueTotalOneTimeAmount() {
            // Disabled — iterates all completed transactions, hidden in UI
            return (0).toFixed(2);
            /* let total = 0;
            for (const t of this.transactionsCompleted || []) {
                total += parseFloat(this.getTransactionTotal(t)) || 0;
            }
            return total.toFixed(2); */
        },
        revenueTotalOneTimeCount() {
            return (this.transactionsCompleted || []).length;
        },
        revenueTotalPendingAmount() {
            // Disabled — iterates all pending transactions, hidden in UI
            return (0).toFixed(2);
            /* let total = 0;
            for (const t of this.transactionsPending || []) {
                total += parseFloat(this.getTransactionTotal(t)) || 0;
            }
            return total.toFixed(2); */
        },
        revenueTotalPendingCount() {
            return (this.transactionsPending || []).length;
        },
        revenueTotalMonthlyTotal() {
            const mrr = parseFloat(this.revenueTotalMRR) || 0;
            const oneTime = parseFloat(this.revenueTotalOneTimeAmount) || 0;
            return (mrr + oneTime).toFixed(2);
        },
        revenueTotalAmount() {
            let total = 0;
            for (const item of this.revenueFiltered || []) {
                if (item.type === 'subscription') {
                    const amount = parseFloat(this.getMembershipTotal(item.raw)) || 0;
                    const interval = item.raw.product ? item.raw.product.interval : null;
                    let monthly = amount;
                    if (interval === 'bi-week') monthly = amount * 2;
                    else if (interval === 'week') monthly = amount * 4;
                    else if (interval === 'bi-year') monthly = amount / 6;
                    else if (interval === 'year') monthly = amount / 12;
                    else if (interval === 'day') monthly = amount * 30;
                    else if (!interval && item.raw.product) {
                        const isExpired = item.raw.expired || (item.raw.lastPaymentStatus || '').toLowerCase() === 'expired';
                        if (!isExpired) {
                            if (item.raw.product.membershipMonths > 0)
                                monthly = amount / item.raw.product.membershipMonths;
                            else if (item.raw.product.membershipDays > 0)
                                monthly = amount * 30 / item.raw.product.membershipDays;
                            else {
                                const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
                                monthly = new Date(item.raw.time).getTime() >= thirtyDaysAgo ? amount : 0;
                            }
                        } else {
                            monthly = 0;
                        }
                    }
                    total += monthly;
                } else {
                    total += parseFloat(this.getAmountForRevenueItem(item)) || 0;
                }
            }
            return total.toFixed(2);
        },
        revenueHeaders() {
            if (this.revenueTypeFilter === 'onetime') {
                return [
                    { text: "", value: "avatar", sortable: false },
                    { text: this.$t('message.transactions_admin_plus.sold_to'), value: "buyer" },
                    { text: this.$t('message.transactions_admin_plus.items'), value: "product" },
                    { text: this.$t('message.transactions_admin_plus.date'), value: "date" },
                    { text: this.$t('message.transactions_admin_plus.price'), value: "price" },
                    { text: this.$t('message.transactions_admin_plus.status'), value: "status", align: "center" },
                ];
            }
            return [
                { text: "", value: "avatar", sortable: false },
                { text: this.$t('message.transactions_admin_plus.sold_to'), value: "buyer" },
                { text: this.$t('message.transactions_admin_plus.subscription'), value: "product" },
                { text: this.$t('message.transactions_admin_plus.frequency'), value: "frequency" },
                { text: this.$t('message.transactions_admin_plus.sale_date'), value: "date" },
                { text: this.$t('message.transactions_admin_plus.billing_day'), value: "billingDay" },
                { text: this.$t('message.transactions_admin_plus.price'), value: "price" },
                { text: this.$t('message.transactions_admin_plus.status'), value: "status", align: "center" },
            ];
        },
    },
    watch: {
        "$store.state.theme"() {
            this.buildIncomeBars();
        },
        async "$route.fullPath"() {
            await this.$nextTick();
            this.tryStartTransactionsAdminPlusTour();
        },
        adminFilter: {
            handler: function () {
                this.filterExpenses();
            },
        },
        userFilter: {
            handler: function (newValue) {
                this.filterTransactions(newValue);
            },
        },
        productFilter: {
            handler: function (newValue) {
                this.productsResultByGraph = false;
                this.filterTransactions(newValue);
            },
        },
        revenueTypeFilter: { handler: function () { this.filterRevenue(); } },
        revenueStatusFilter: { handler: function () { this.filterRevenue(); } },
        revenueUserFilter: {
            handler: function (v) {
                this.subscriptionUserFilter = v;
                this.filterSubscriptions(this.subscriptionsFilter);
                this.filterRevenue();
            }
        },
        revenueProductFilter: {
            handler: function (v) {
                this.subscriptionProductFilter = v;
                this.productFilter = v;
                this.filterSubscriptions(this.subscriptionsFilter);
                if (this.productFilter) this.filterTransactions();
                this.filterRevenue();
            }
        },
        subscriptionsFilter: {
            handler: function (val) {
                if (val === 'cancelled' && this.cancelledFiltered.length === 0) {
                    this.getCancelledSubcriptions();
                }
                this.filterSubscriptions(val);
                this.filterRevenue();
            },
        },
        subscriptionTagFilter: {
            handler: function () {
                this.filterSubscriptions(this.subscriptionsFilter);
                this.filterRevenue();
            },
        },
        pendingFilter: {
            handler: function () {
                this.transactions = this.pendingFilter ? this.transactionsPending : this.transactionsCompleted;
                this.transactionsFiltered = this.transactions;
                this.filterRevenue();
            },
        },
    },
    methods: {
        stripTransactionsAdminPlusTourQuery() {
            if (this.$route.query.tour !== "true") {
                return;
            }
            const query = { ...this.$route.query };
            delete query.tour;
            this.$router.replace({
                path: this.$route.path,
                query
            }).catch(() => { });
        },
        async tryStartTransactionsAdminPlusTour() {
            if (this._transactionsAdminPlusTourLaunching) {
                return;
            }
            const isTransactionsRoute =
                this.$route.name === "transactions-adminplus" ||
                this.$route.name === "transactions-adminplus-tab";
            if (!isTransactionsRoute || this.$route.query.tour !== "true") {
                return;
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));

            this._transactionsAdminPlusTourLaunching = true;
            try {
                const appTour = this.$tours && this.$tours["custom-onboarding"];
                if (appTour && typeof appTour.stop === "function") {
                    appTour.stop();
                }
                this.$emit("expand-nav-for-tour");
                await this.$nextTick();
                const delayMs = 500;
                await new Promise((resolve) => setTimeout(resolve, delayMs));
                const onboarding = this.$refs.transactionsAdminPlusTour;
                if (onboarding && typeof onboarding.start === "function") {
                    await onboarding.start();
                }
                this.stripTransactionsAdminPlusTourQuery();
            } finally {
                this._transactionsAdminPlusTourLaunching = false;
            }
        },
        getProductTimline() {
            if (this.productsResultByGraph) {
                const product = this.activeTab === 1 ? this.revenueProductFilter : this.productFilter;
                let data = {
                    product,
                    now: new Date(),
                    months: 12
                };
                this.loadingProductTimeline = true;
                Api2()
                    .post("payments/managedacademy/" + this.$store.state.managedAcademy + "/products/timeline", data)
                    .then((response) => {
                        if (response.data && response.data.timeline.noData) {
                            this.productTimelineGraph = {
                                noData: true
                            }
                        } else {
                            // 1. Map the ISO strings to localized strings using your translation function
                            const localizedCategories = response.data.timeline.dates.map(dateStr => {
                                return this.$d(new Date(dateStr), 'month_year', this.$i18n.locale);
                            });

                            this.productTimelineGraph = {
                                data: [{
                                    name: this.$t("message.transactions_admin_plus.income"),
                                    data: response.data.timeline.data
                                }],
                                options: {
                                    chart: {
                                        type: 'bar',
                                        toolbar: { show: false },
                                        background: 'none'
                                    },
                                    // Required to make dataLabels stay on top of the bars
                                    plotOptions: {
                                        bar: {
                                            dataLabels: {
                                                position: 'top',
                                            },
                                        }
                                    },
                                    dataLabels: {
                                        enabled: true,
                                        offsetY: -20,
                                        style: {
                                            fontSize: '12px',
                                            // Ensuring labels match theme mode for visibility
                                            colors: [this.isDarkMode() ? '#FFFFFF' : '#303030']
                                        },
                                        formatter: (val) => {
                                            return this.currencySymbol + val.toLocaleString();
                                        }
                                    },
                                    colors: [this.themeColor('secondary')],
                                    stroke: {
                                        width: [0, 0, 0, 4, 0],
                                        curve: 'smooth'
                                    },
                                    // Using the translated categories here
                                    xaxis: {
                                        categories: localizedCategories,
                                        axisBorder: { show: false },
                                        axisTicks: { show: false }
                                    },
                                    yaxis: {
                                        show: false,
                                        labels: { show: false },
                                        axisBorder: { show: false },
                                        axisTicks: { show: false }
                                    },
                                    theme: { mode: this.isDarkMode() ? 'dark' : 'light' },
                                    // Added padding top so the currency labels at the highest bar aren't clipped
                                    grid: {
                                        show: false,
                                        padding: {
                                            top: 25
                                        }
                                    },
                                    legend: {
                                        show: false,
                                    },
                                    tooltip: {
                                        shared: true,
                                        intersect: false,
                                        y: { formatter: (val) => this.currencySymbol + val.toFixed(2) }
                                    }
                                }
                            };
                        }
                        this.loadingProductTimeline = false;
                    });
            }
        },
        onUpdateSelectedIncomeGraphMonths(months) {
            this.selectedIncomeGraphMonths = Number(months);
        },
        onQuarterlyChanged(/** @type {boolean} */ val) {
            this.incomeBarQuarterly = !!val;
            this.buildIncomeBars();
        },
        onUpdateSelectedProductsGraphMonths(/** @type {number} */ months) {
            this.selectedProductsGraphMonths = Number(months);
            this.productsGraph.ready = false;
            const d = new Date();
            d.setDate(1);
            d.setMonth(d.getMonth() - this.selectedProductsGraphMonths);
            this.loadProductsCharts(d);
        },
        filterDatedIncome(months = null) {
            if (months !== null && months !== undefined) {
                this.selectedIncomeGraphMonths = Number(months);
            }
            this.loadingBottomCharts = true;
            this.loadingIncomeTrendline = true;
            const d = new Date();

            d.setDate(1); // Set to the 1st to prevent overflow (e.g., Jan 30 -> Feb 30)
            d.setMonth(d.getMonth() - this.selectedIncomeGraphMonths);
            this.loadProductsCharts(d);
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/aggregates/v3/trendline?months=" + this.selectedIncomeGraphMonths
                )
                .then((response) => {
                    if (response && response.data.income && response.data.income.length) {
                        this.buildIncomeBars(response.data.income);
                        this.buildIncomeMonthlyData(response.data.income);
                        this.loadingBottomCharts = false;
                    }
                    this.loadingIncomeTrendline = false;
                });
        },
        downloadMembershipsTable() {
            this.downloadingMembershipsTable = true;
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/memberships/csv"
                )
                .then((response) => {
                    this.downloadingMembershipsTable = false;
                    let blob = new Blob([response.data], { type: "text/csv" });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download =
                        this.academy.name +
                        "_Memberships_" +
                        new Date().toISOString() +
                        "_" +
                        ".csv";
                    link.click();
                    this.showAlert("success", this.$t("message.transactions_admin_plus.success"));
                }).catch((err) => {
                    this.downloadingMembershipsTable = false;
                    if (err)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                    this.downloadingAllTransactions = false;
                });
        },
        colorExpenses() {
            if (this.expenses && this.expenses[0] && !this.expenses[0].color) {
                for (let expense of this.expenses) {
                    const cat = expense.tags && expense.tags.length > 0 ? expense.tags[0] : null;
                    if (cat) {
                        expense.color = this.expensesGraphs.colors[cat];
                    }
                }
            }
        },
        onUpdateExpensesGraphRange(range) {
            this.expensesGraphRange = range;
            this.loadExpensesCharts(range);
        },
        onUpdateExpensesTagFilter(tag) {
            this.expensesTagFilter = tag;
            this.getExpenses();
        },
        onUpdateExpensesFromFilter(date) {
            this.fromFilter = date;
            this.getExpenses();
        },
        onUpdateExpensesToFilter(date) {
            this.toFilter = date;
            this.getExpenses();
        },
        loadExpensesCharts(graphRange = null) {
            // Graph-range mode: update only the breakdown chart shown in `ViewExpenses.vue`
            if (graphRange) {
                let d1 = new Date();
                if (graphRange === 'thismonth') {
                    d1.setDate(1);
                    d1.setHours(0);
                    d1.setMinutes(0);
                    d1.setSeconds(0);
                    d1.setMilliseconds(0);
                } else if (graphRange === 'month') {
                    // Start of last calendar month
                    d1.setDate(1);
                    d1.setMonth(d1.getMonth() - 1);
                    d1.setHours(0);
                    d1.setMinutes(0);
                    d1.setSeconds(0);
                    d1.setMilliseconds(0);
                } else if (graphRange === '3') {
                    // Start of the calendar month 3 months ago
                    d1.setDate(1);
                    d1.setMonth(d1.getMonth() - 3);
                    d1.setHours(0);
                    d1.setMinutes(0);
                    d1.setSeconds(0);
                    d1.setMilliseconds(0);
                } else if (graphRange === '6') {
                    // Start of the calendar month 6 months ago
                    d1.setDate(1);
                    d1.setMonth(d1.getMonth() - 6);
                    d1.setHours(0);
                    d1.setMinutes(0);
                    d1.setSeconds(0);
                    d1.setMilliseconds(0);
                } else if (graphRange === '12') {
                    // Start of the calendar month 12 months ago
                    d1.setDate(1);
                    d1.setMonth(d1.getMonth() - 12);
                    d1.setHours(0);
                    d1.setMinutes(0);
                    d1.setSeconds(0);
                    d1.setMilliseconds(0);
                } else if (graphRange === 'all') {
                    d1 = new Date(0);
                }

                const d2 = new Date(d1);
                this.expensesGraphs.selectedRange = { ready: false, options: {}, data: [] };

                return Api()
                    .get("payments/academy/" + this.$store.state.managedAcademy + "/expenses/aggregates?d1=" + d1 + "&d2=" + d2)
                    .then((response) => {
                        const data = response.data;
                        if (!data || !data.data || !data.data.thisMonth) return;

                        const vm = this;
                        let graphColors = [];
                        let graphData = [];
                        let labels = [];
                        for (const i of data.data.thisMonth) {
                            graphData.push(i.total != null ? i.total : 0);
                            labels.push(i.category != null ? String(i.category) : 'Other');
                            const existingColor = vm.expensesGraphs.colors && vm.expensesGraphs.colors[i.category]
                                ? vm.expensesGraphs.colors[i.category]
                                : vm.themeColor('error');
                            graphColors.push(existingColor || '#EF5350');
                        }

                        const totalExpenses = graphData.reduce((sum, v) => sum + (parseFloat(v) || 0), 0);

                        vm.expensesGraphs.selectedRange.options = {
                            legend: {
                                position: 'bottom'
                            },
                            stroke: { show: false },
                            fill: { colors: graphColors },
                            theme: { mode: vm.isDarkMode() ? 'dark' : 'light' },
                            chart: { background: 'none' },
                            labels: labels,
                            tooltip: {
                                y: {
                                    formatter: function (value) {
                                        return vm.currencySymbol + '' + value;
                                    }
                                }
                            },
                            plotOptions: {
                                pie: {
                                    donut: {
                                        size: '50%',
                                        labels: {
                                            show: true,
                                            total: {
                                                show: true,
                                                showAlways: true,
                                                label: 'Total',
                                                fontSize: '16px',
                                                fontWeight: 400,
                                                color: '#9e9e9e',
                                                formatter: function () {
                                                    return vm.currencySymbol + totalExpenses.toFixed(2);
                                                }
                                            },
                                            value: {
                                                show: true,
                                                fontSize: '24px',
                                                fontWeight: 600,
                                                color: '#263238',
                                                formatter: function (val) {
                                                    return vm.currencySymbol + parseFloat(val).toFixed(2);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        };

                        vm.expensesGraphs.selectedRange.data = graphData;
                        vm.expensesGraphs.selectedRange.ready = true;
                    });
            }

            let d1 = new Date();
            let d2 = new Date();
            d1.setDate(1);
            d1.setHours(0);
            d1.setMinutes(0);
            d2.setMonth(0);
            d2.setDate(1);
            d2.setHours(0);
            d2.setMinutes(0);

            return Api()
                .get("payments/academy/" + this.$store.state.managedAcademy + "/expenses/aggregates?d1=" + d1 + "&d2=" + d2)
                .then((response) => {

                    const data = response.data;
                    if (data) {
                        let ready = false;
                        //expensesGraphs
                        let vm = this;
                        let allCategories = data.data.categories;
                        const colors = [
                            this.themeColor('gold'),
                            this.themeColor('orange'),
                            this.themeColor('blue'),
                            this.themeColor('success'),
                            this.themeColor('yellow'),
                            this.themeColor('accent'),
                            this.themeColor('brown'),
                            this.themeColor('silver'),
                            this.themeColor('secondary')
                        ];
                        let colorsMap = {};
                        let index = 0;
                        for (const cat of allCategories) {
                            if (index <= 8) {
                                colorsMap[cat] = colors[index];
                            } else {
                                const randomNum = Math.floor(Math.random() * 9);
                                colorsMap[cat] = this.getRandomColorVariation(colors[randomNum]);
                            }
                            index++;
                        }
                        this.expensesGraphs.colors = colorsMap;
                        if (data.data.thisMonth) {
                            ready = true;

                            let graphColorsThisMonth = [];
                            let graphData = [];
                            let thisMonthLabels = [];
                            for (const i of data.data.thisMonth) {
                                graphData.push(i.total != null ? i.total : 0);
                                thisMonthLabels.push(i.category != null ? String(i.category) : 'Other');
                                graphColorsThisMonth.push(colorsMap[i.category] || this.themeColor('error') || '#EF5350');
                            }
                            this.expensesGraphs.thisMonth.options = {
                                legend: {
                                    position: 'bottom'
                                },
                                stroke: { show: false },
                                fill: {
                                    colors: graphColorsThisMonth,
                                },
                                theme: {
                                    mode: this.isDarkMode() ? 'dark' : 'light',
                                },
                                chart: { background: 'none' },
                                labels: thisMonthLabels,
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return vm.currencySymbol + '' + value;
                                        }
                                    },
                                },
                            };
                            this.expensesGraphs.thisMonth.data = graphData;
                        }
                        if (data.data.thisYear) {
                            ready = true;

                            let graphColorsThisYear = [];
                            let graphData = [];
                            let thisYearLabels = [];
                            for (const i of data.data.thisYear) {
                                graphData.push(i.total != null ? i.total : 0);
                                thisYearLabels.push(i.category != null ? String(i.category) : 'Other');
                                graphColorsThisYear.push(colorsMap[i.category] || this.themeColor('error') || '#EF5350');
                            }
                            this.expensesGraphs.thisYear.options = {
                                legend: {
                                    position: 'bottom'
                                },
                                stroke: { show: false },
                                theme: {
                                    mode: this.isDarkMode() ? 'dark' : 'light',
                                },
                                fill: {
                                    colors: graphColorsThisYear,
                                },
                                chart: { background: 'none' },
                                labels: thisYearLabels,
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return vm.currencySymbol + '' + value;
                                        }
                                    },
                                },
                            };
                            this.expensesGraphs.thisYear.data = graphData;
                            //console.log('graphColorsThisYear: ', graphColorsThisYear);
                        }
                        if (ready) {
                            this.colorExpenses();
                        }
                        this.expensesGraphs.ready = true;

                        // Update expense donut chart with categories if available and on financial overview tab
                        if (this.activeTab === 0 &&
                            this.expensesGraphs.thisMonth.data &&
                            this.expensesGraphs.thisMonth.data.length > 0) {
                            this.buildExpenseDonutChart({ expense: 0 });
                        }
                    }
                });
        },
        loadProductsCharts(d1) {
            if (!d1) {
                d1 = new Date();
                d1.setDate(1); // Set to the 1st to prevent overflow (e.g., Jan 30 -> Feb 30)
                d1.setMonth(d1.getMonth() - 12);
            } else {
                d1.setHours(0);
                d1.setMinutes(0);
            }
            Api2()
                .get("payments/academy/" + this.$store.state.managedAcademy + "/products/aggregates?d1=" + d1)
                .then((response) => {
                    const data = response.data;
                    const currencySymbol = this.currencySymbol;
                    let productAmounts = [];
                    const sold = this.$t('message.transactions_admin_plus.sold');
                    const smallDisplay = this.isSmallerDisplay();
                    let vm = this;
                    if (data) {
                        this.productsGraph.products = {};
                        if (data.data.thisYear && data.data.thisYear.length > 0) {
                            let graphData = [];
                            let categories = [];
                            const palette = [
                                this.themeColor('secondary'), this.themeColor('graph1'), this.themeColor('graph2'),
                                this.themeColor('orange'), this.themeColor('gold'), this.themeColor('purple'),
                                this.themeColor('blue'), this.themeColor('error')
                            ];
                            for (const i of data.data.thisYear) {
                                graphData.push(i.totalCounts);
                                productAmounts.push(i.totalAmount);
                                categories.push(i.name);
                            }
                            this.productsGraph.thisYear.options = {
                                legend: {
                                    show: smallDisplay ? false : true,
                                    position: smallDisplay ? 'bottom' : 'right'
                                },
                                stroke: { show: false },
                                colors: categories.map((_, i) => palette[i % palette.length]),
                                theme: {
                                    mode: this.isDarkMode() ? 'dark' : 'light',
                                },
                                chart: {
                                    background: 'none',
                                    events: {
                                        dataPointSelection: (/** @type {any} */ _event, /** @type {any} */ _chartContext, /** @type {any} */ config) => {
                                            if (vm.isSmallerDisplay()) {
                                                const idx = config.dataPointIndex;

                                                // 2. Access your data using that index
                                                const label = categories[idx];
                                                const count = graphData[idx];
                                                const amount = productAmounts[idx];
                                                vm.pieChartSelection = {
                                                    label: label,
                                                    count: count,
                                                    revenue: vm.currencySymbol + amount
                                                };
                                            }
                                        }
                                    }
                                },
                                plotOptions: {
                                    pie: {
                                        expandOnClick: true, // Ensure this is true
                                        dataLabels: {
                                            offset: -5 // Adjusts label position inside slices
                                        }
                                    }
                                },
                                labels: categories,
                                tooltip: {
                                    y: {
                                        formatter: function (value, data) {
                                            return value + ' ' + sold + ", " + currencySymbol + productAmounts[data.seriesIndex];
                                        }
                                    },
                                },
                            };
                            this.productsGraph.thisYear.data = graphData;
                            this.productsGraph.ready = true;
                        }
                    }
                });
        },
        getProducts() {
            Api2()
                .get("admins/academy/" + this.$store.state.managedAcademy + "/products ")
                .then((response) => {
                    const data = response.data;
                    if (data) {
                        //We back
                        for (const p of data.goods) {
                            if (p.isMembership)
                                this.membershipProducts.push({ value: p._id, text: p.name });
                            else
                                this.products.push({ value: p._id, text: p.name });
                        }
                        for (const p of data.subscriptions)
                            this.membershipProducts.push({ value: p._id, text: p.name });
                    }
                })
                .catch((e) => {
                    if (e) this.showAlert("error", "Oops!", ":(");
                });
        },
        getPayoutStatusColor(status) {
            //paid, pending, in_transit, canceled or failed
            if (status == 'paid')
                return this.themeColor('success');
            else if (status == 'success')
                return this.themeColor('success');
            else if (status == 'pending')
                return this.themeColor('pending');
            else if (status == 'in_transit') {
                return this.themeColor('gold');
            } else if (status == 'canceled')
                return this.themeColor('error');
            else if (status == 'failed')
                return this.themeColor('error');
            else if (status == 'succeeded') {
                return this.themeColor('success');
            }
        },
        getBalances() {
            this.payoutsHistory.loading = true;
            if (!this.stripeReady) {
                this.payoutsHistory.loading = false;
                return;
            }
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/balances?today=" + (new Date().toISOString())
                )
                .then((response) => {
                    if (response.data) {
                        this.payoutsHistory.data = response.data.data.payouts;
                        this.payoutsHistory.inTransit = response.data.data.inTransit;
                        this.payoutsHistory.future = response.data.data.future;
                        this.payoutsHistory.headers = [
                            { text: this.$t("message.transactions_admin_plus.created"), value: "started" },
                            { text: this.$t("message.transactions_admin_plus.arriving"), value: "arrival" },
                            { text: this.$t("message.transactions_admin_plus.amount"), value: "amount" },
                            { text: this.$t("message.transactions_admin_plus.status"), value: "status" },
                        ];
                        this.payoutsHistory.loading = false;
                    }
                })
        },
        subscriptionsSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index[0] == 'time') {
                    if (!isDesc[0])
                        return new Date(a[index]) - new Date(b[index]);
                    else
                        return new Date(b[index]) - new Date(a[index]);
                } if (index[0] == 'displayDate') {
                    if (!isDesc[0])
                        return a[index] - b[index];
                    else
                        return b[index] - a[index];
                } else if (index[0] == 'amount') {
                    if (!isDesc[0])
                        return a[index] - b[index];
                    else
                        return b[index] - a[index];
                } else if (index[0] == 'lastPaymentStatus') {
                    let aVal = a[index] == 'active' ? 1 : (a[index] == 'trialing' ? 2 : (a[index] == 'paused' ? 3 : 4));
                    let bVal = b[index] == 'active' ? 1 : (b[index] == 'trialing' ? 2 : (b[index] == 'paused' ? 3 : 4));
                    if (!isDesc[0])
                        return aVal - bVal;
                    else
                        return bVal - aVal;
                } else {
                    if (typeof a[index] !== 'undefined') {
                        let aVal = a[index];
                        let bVal = b[index];
                        if (index[0] == 'buyer') {
                            aVal = a[index].displayName;
                            bVal = b[index].displayName;
                        }
                        if (!isDesc[0]) {
                            return aVal.toLowerCase().localeCompare(bVal.toLowerCase());
                        }
                        else {
                            return bVal.toLowerCase().localeCompare(aVal.toLowerCase());
                        }
                    }
                }
            });
            return items;
        },
        getCancelledSubcriptions() {
            this.cancelledFiltered = [];
            this.loadingCancelledSubscriptions = true;
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/transactions/recurrent/cancelled"
                )
                .then((response) => {
                    if (response.data) {
                        this.cancelledFiltered = response.data.cancelled;
                    }
                    this.loadingCancelledSubscriptions = false;
                    if (this.subscriptionsFilter === 'cancelled') {
                        this.filterSubscriptions();
                        this.filterRevenue();
                    }
                }).catch((err) => {
                    if (err)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                });
        },
        goToOneTimeTransaction(t) {
            if (t.items && t.items.length > 0)
                this.goToTransaction(t);
            else
                this.navigateTo({ name: 'viewtransaction', params: { sessionId: t._id } });
        },
        fetchBothOneTimeTransactions() {
            this.loadingOneTimeTransactions = true;
            const baseUrl = "payments/academy/" + this.$store.state.managedAcademy + "/transactions/onetime/filter";
            const completedPromise = Api().post(baseUrl, {});
            const pendingPromise = Api().post(baseUrl, { pending: true });
            Promise.all([completedPromise, pendingPromise])
                .then(([completedRes, pendingRes]) => {
                    this.transactionsCompleted = (completedRes.data && completedRes.data.transactions) || [];
                    this.transactionsPending = (pendingRes.data && pendingRes.data.transactions) || [];
                    this.transactions = this.pendingFilter ? this.transactionsPending : this.transactionsCompleted;
                    this.transactionsFiltered = this.transactions;
                    this.loadingOneTimeTransactions = false;
                    this.filterRevenue();
                })
                .catch((err) => {
                    if (err)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                    this.loadingOneTimeTransactions = false;
                });
        },
        loadRevenue() {
            if (!this.loading) this.getRecurrentTransactions();
            if (!this.loadingOneTimeTransactions) this.fetchBothOneTimeTransactions();
        },
        filterRevenue() {
            const normalized = [];
            const typeFilter = this.revenueTypeFilter;
            const userFilter = (this.revenueUserFilter || '').toLowerCase();
            const productFilter = this.revenueProductFilter;
            if (typeFilter === 'subscriptions') {
                for (const s of this.subscriptionsFiltered || []) {
                    normalized.push({
                        type: 'subscription',
                        raw: s,
                        revenueKey: 'sub-' + s._id
                    });
                }
            }
            if (typeFilter === 'onetime') {
                const txList = this.transactions || [];
                for (const t of txList) {
                    if (userFilter && userFilter.length >= 1) {
                        const name = (t.buyer && t.buyer.displayName || t.email || '').toLowerCase();
                        if (name.indexOf(userFilter) < 0) continue;
                    }
                    if (productFilter) {
                        const hasProduct = (t.product && t.product._id === productFilter) ||
                            (t.items && t.items.some(i => i.product && (i.product._id === productFilter || i.product === productFilter)));
                        if (!hasProduct) continue;
                    }
                    normalized.push({
                        type: 'onetime',
                        raw: t,
                        revenueKey: 'ot-' + t._id
                    });
                }
            }
            normalized.sort((a, b) => new Date(b.raw.time || 0).getTime() - new Date(a.raw.time || 0).getTime());

            // Apply status filter
            const statusFilter = this.revenueStatusFilter;
            if (statusFilter && statusFilter !== 'all') {
                this.revenueFiltered = normalized.filter(item => {
                    const itemStatus = this.getRevenueItemStatusForFilter(item);
                    // "paid" includes active subscriptions (they have paid to be active)
                    if (statusFilter === 'paid') return itemStatus === 'paid' || itemStatus === 'active';
                    return itemStatus === statusFilter;
                });
            } else {
                this.revenueFiltered = normalized;
            }
        },
        getRevenueItemStatusForFilter(item) {
            if (item.type === 'subscription') {
                const status = (item.raw.lastPaymentStatus || '').toLowerCase();
                if (['active', 'trialing', 'paused'].includes(status)) return 'active';
                if (['succeeded', 'success'].includes(status)) return 'paid';
                if (['pending_payment', 'past_due', 'unpaid', 'open'].includes(status)) return 'pending';
                if (status && status.indexOf('expired') >= 0) return 'expired';
                return status ? 'pending' : 'active';
            } else {
                const r = item.raw;
                if (r.completed) return 'paid';
                if (r.expired) return 'expired';
                if (r.cancelled || (r.status && String(r.status).toLowerCase() === 'refunded')) return 'refunded';
                return 'pending';
            }
        },
        getAmountForRevenueItem(item) {
            if (item.type === 'subscription') return this.getMembershipTotal(item.raw);
            return this.getTransactionTotal(item.raw);
        },
        getStatusColorForRevenueItem(item) {
            if (item.type === 'subscription') return this.getTransactionStatusColor(item.raw.lastPaymentStatus, item.raw);
            return this.getStatusColor(item.raw);
        },
        getStatusTextForRevenueItem(item) {
            if (item.type === 'subscription') {
                if (item.raw.cancellationDate) return this.$t('message.transactions_admin_plus.scheduled_cancellation');
                if (item.raw.pauseDate) return this.$t('message.transactions_admin_plus.scheduled_pause');
                const status = item.raw.lastPaymentStatus || '';
                const text = this.getTransactionStatusText(status);
                if (text !== 'unknown') return text;
                // Unrecognized/null status — item is cancelled
                const isManual = item.raw.product && item.raw.product.type === 'good';
                const isRecurrent = !!item.raw.subscription;
                if (isManual || !isRecurrent) return this.$t('message.expired');
                return this.$t('message.inactive');
            }
            if (item.raw.completed) return this.$t('message.transactions_admin_plus.completed');
            if (item.raw.expired) return this.$t('message.transactions_admin_plus.expired');
            if (item.raw.cancelled) return this.$t('message.transactions_admin_plus.cancelled');
            return this.$t('message.transactions_admin_plus.pending_payment');
        },
        navigateToRevenueItem(item) {
            if (item.type === 'subscription') {
                this.navigateTo({ name: 'viewtransaction', params: { sessionId: item.raw._id } });
            } else {
                this.goToOneTimeTransaction(item.raw);
            }
        },
        goToNewEvent() {
            this.navigateTo({
                name: "manageacademyeventplus",
                params: { eventId: 'new' },
            });
        },
        goToExpense(item) {
            this.navigateTo({ name: 'manageexpense-adminplus', params: { transactionId: item._id } });
        },
        addNewExpense() {
            this.navigateTo({ name: 'manageexpense-adminplus', params: { transactionId: 'new' } });
        },
        goToTransaction(i) {
            if (i) {
                if (i.items && i.items.length > 0)
                    this.navigateTo({ name: 'viewitemstransaction', params: { transactionId: i._id } });
                else
                    this.navigateTo({ name: 'viewtransaction', params: { sessionId: i._id } })
            }
        },
        selectTab(num) {
            try {
                const n = parseInt(num, 10);
                if (!isNaN(n) && n >= 0 && n <= 3) this.activeTab = n;
            } catch (err) {
                console.log(err, 'Invalid tab: ', num);
            }
        },
        clickTab(tab) {
            if (tab != this.activeTab) {
                this.activeTab = tab;
                this.getTransactions();
                this.navigateTo({
                    name: "transactions-adminplus-tab",
                    params: { tabId: tab },
                });
                if (tab == 3) {
                    this.loadExpensesCharts().then(() => {
                        this.loadExpensesCharts(this.expensesGraphRange);
                    });
                    this.getExpenses();
                } else if (tab == 0 || !tab) {
                    this.loadProductsCharts();
                    this.loadExpensesCharts(); // Load expense data for donut chart
                }
            }
        },
        downloadAggregatedTransactions() {
            this.downloadingAllTransactions = true;
            let params = "";
            if (this.byDatesReport) {
                if (!this.fromFilter)
                    this.fromFilter = new Date();
                this.fromFilter = this.toBeginningOfDay(this.fromFilter);
                if (!this.toFilter)
                    this.toFilter = new Date();
                this.toFilter = this.toEndOfDay(this.toFilter);
                params = "&from=" + this.fromFilter + '&to=' + this.toFilter;
            } else {
                const data = this.getMonthRange(this.monthAmount);
                params = "&from=" + data.from + '&to=' + data.to;
            }
            if (this.groupByMonth)
                params += '&group_by=month'
            else
                params += '&group_by=category'
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/aggregates/v2?csv=true" +
                    (this.retailOnly ? '&retail_only=true' : '') +
                    (this.expensesOnly ? '&expenses_only=true' : '') +
                    (this.membershipsOnly ? '&membership_only=true' : '') + params
                )
                .then((response) => {
                    this.downloadingAllTransactions = false;
                    this.showAlert("success", this.$t("message.transactions_admin_plus.report_in_progress", [response.data.sendTo]));
                }).catch((err) => {
                    if (err)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                    this.downloadingAllTransactions = false;
                });
        },
        downloadAllTransactions() {
            if (this.groupByMonth || this.groupByCategory) {
                return this.downloadAggregatedTransactions();
            }
            this.downloadingAllTransactions = true;
            let params = "";
            if (this.byDatesReport) {
                if (!this.fromFilter)
                    this.fromFilter = new Date();
                this.fromFilter = this.toBeginningOfDay(this.fromFilter);
                if (!this.toFilter)
                    this.toFilter = new Date();
                this.toFilter = this.toEndOfDay(this.toFilter);
                params = "&from=" + this.fromFilter + '&to=' + this.toFilter;
            } else {
                const data = this.getMonthRange(this.monthAmount);
                params = "&from=" + data.from + '&to=' + data.to;
            }
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/aggregates/v2?csv=true&detailed=true" +
                    (this.retailOnly ? '&retail_only=true' : '') +
                    (this.expensesOnly ? '&expenses_only=true' : '') +
                    (this.membershipsOnly ? '&membership_only=true' : '') + params
                )
                .then((response) => {
                    this.showAlert("success", this.$t("message.transactions_admin_plus.report_in_progress", [response.data.sendTo]));
                    this.downloadingAllTransactions = false;
                    this.detailedReportDialog = false;
                    this.retailOnly = false;
                    this.expensesOnly = false;
                    this.membershipsOnly = false;
                }).catch((err) => {
                    if (err)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                    this.downloadingAllTransactions = false;
                });
        },
        viewInvoiceTransaction(i) {
            if (i && i.items > 0) {
                this.navigateTo({
                    name: "viewitemstransaction",
                    params: { transactionId: i.transaction },
                });
            } else {
                if (i.transaction) {
                    this.navigateTo({
                        name: "viewtransaction",
                        params: { sessionId: i.transaction },
                        query: { invoiceId: i.invoice }
                    });
                } else {
                    this.navigateTo({
                        name: "viewpayment",
                        params: { paymentIntentId: i.id },
                    });
                }
            }
        },
        buildIncomeMonthlyData(data) {
            if (!data)
                return;
            let categories = [];
            let graphData = [
                { name: this.$t("message.transactions_admin_plus.expenses"), data: [] },
                { name: this.$t("message.transactions_admin_plus.retail"), data: [] },
                { name: this.$t("message.transactions_admin_plus.events"), data: [] },
                { name: this.$t("message.transactions_admin_plus.memberships"), data: [] }
            ];
            const totalMonths = data.length;
            for (let i = totalMonths; i > 0; i--) {
                const month = new Date();
                // Set to the 1st of the month first to avoid overflow issues
                month.setDate(1);
                month.setMonth(month.getMonth() - i);
                categories.push(this.$d(month, "month_year", this.$i18n.locale));
            }
            for (const i of data) {
                graphData[0].data.push(i.expenses);
                graphData[1].data.push(i.retail);
                graphData[2].data.push(i.events);
                graphData[3].data.push(i.memberships);
            }

            this.incomeTrendline = {
                data: graphData,
                options: {
                    labels: { show: false },
                    colors: [this.themeColor('error'), this.themeColor('graph1'), this.themeColor('graph2'), this.themeColor('secondary')],
                    xaxis: {
                        categories: categories,
                    },
                    yaxis: {
                        labels: {
                            show: true,
                            formatter: (value) => {
                                return this.currencySymbol + Math.round(value);
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3
                    },
                    theme: {
                        mode: this.isDarkMode() ? 'dark' : 'light',
                    },
                    chart: {
                        toolbar: {
                            show: false
                        },
                        background: 'none'
                    },
                    legend: {
                        show: this.isSmallerDisplay(),
                        position: 'bottom'
                    },
                    grid: {
                        show: true,
                        borderColor: '#EAEAEA',
                        strokeDashArray: 0,
                        xaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        y: {
                            formatter: (value) => {
                                return this.currencySymbol + Math.round(value).toLocaleString();
                            }
                        },
                        x: {
                            show: true
                        }
                    },
                }
            }
            this.loadingIncomeTrendline = false;
        },
        buildIncomeBars(data) {
            if (!data && this.incomeBars && this.incomeBars.raw)
                data = this.incomeBars.raw;
            let categories = [];
            let retail = [], events = [], memberships = [], expenses = [], netTotal = [];

            if (this.incomeBarQuarterly) {
                const quarters = {};

                data.forEach((item, index) => {
                    // 1. Calculate the date for this specific data point
                    const date = new Date();
                    date.setMonth(date.getMonth() - (data.length - index));

                    // 2. Create a unique key like "Q1 2025"
                    const qNum = Math.floor(date.getMonth() / 3) + 1;
                    const qKey = `Q${qNum} ${date.getFullYear()}`;

                    // 3. Initialize or sum the values
                    if (!quarters[qKey]) {
                        quarters[qKey] = { retail: 0, events: 0, memberships: 0, expenses: 0 };
                    }
                    quarters[qKey].retail += item.retail;
                    quarters[qKey].events += item.events;
                    quarters[qKey].memberships += item.memberships;
                    quarters[qKey].expenses += item.expenses;
                });

                // 4. Map the grouped object back into your arrays
                Object.keys(quarters).forEach(key => {
                    const q = quarters[key];
                    categories.push(key);
                    retail.push(q.retail);
                    events.push(q.events);
                    memberships.push(q.memberships);
                    expenses.push(q.expenses);
                    netTotal.push(q.retail + q.events + q.memberships - Math.abs(q.expenses));
                });
            } else {
                for (let i = data.length; i > 0; i--) {
                    const month = new Date();
                    // Set to the 1st of the month first to avoid overflow issues
                    month.setDate(1);
                    month.setMonth(month.getMonth() - i);
                    categories.push(this.$d(month, "month_year", this.$i18n.locale));
                }
                for (const i of data) {
                    retail.push(i.retail);
                    events.push(i.events);
                    memberships.push(i.memberships);
                    expenses.push(i.expenses);
                    netTotal.push(i.retail + i.events + i.memberships - Math.abs(i.expenses));
                }
            }

            // Map data to the graphData array
            let graphData = [
                { name: this.$t("message.transactions_admin_plus.retail"), type: 'column', data: retail },
                { name: this.$t("message.transactions_admin_plus.events"), type: 'column', data: events },
                { name: this.$t("message.transactions_admin_plus.memberships"), type: 'column', data: memberships },
                { name: this.$t("message.transactions_admin_plus.total_profit"), type: 'line', data: netTotal },
                { name: this.$t("message.transactions_admin_plus.expenses"), type: 'line', data: expenses }
            ];

            this.incomeBars = {
                raw: data,
                data: graphData,
                options: {
                    chart: {
                        type: 'line',
                        stacked: true,
                        toolbar: { show: false },
                        background: 'none'
                    },
                    colors: [
                        this.themeColor('orange'),
                        this.themeColor('graph2'),
                        this.themeColor('secondary'),
                        this.themeColor('primary'),
                        this.themeColor('error'),
                    ],
                    stroke: {
                        width: [0, 0, 0, 4, 0],
                        curve: 'smooth'
                    },
                    xaxis: { categories: categories },
                    yaxis: {
                        show: false, // Hides the entire axis (numbers, title, and the line)
                        labels: {
                            show: false // Specifically ensures the numbers are hidden
                        },
                        axisBorder: {
                            show: false // Removes the vertical line on the left
                        },
                        axisTicks: {
                            show: false // Removes the small tick marks
                        }
                    },
                    theme: { mode: this.isDarkMode() ? 'dark' : 'light' },
                    grid: { show: false },
                    legend: {
                        show: false,
                    },
                    tooltip: {
                        shared: true,
                        y: { formatter: (val) => this.currencySymbol + val.toFixed(2) }
                    }
                }
            };
        },
        buildCurrentMonthGraph(data) {

            console.log('Building current month graph with data: ', { data });
            this.currentMonthTotal = 0;
            let graphData = [
                { name: 'Total', data: [] },
            ];
            let categories = [this.$t("message.transactions_admin_plus.expenses"), this.$t("message.transactions_admin_plus.retail"), this.$t("message.transactions_admin_plus.events"), this.$t("message.transactions_admin_plus.memberships")];
            const currentMonthData = data['month'];
            //categories.push(this.$d(new Date(d.month), 'month_year', this.$i18n.locale));
            graphData[0].data.push(currentMonthData.expense ? Math.abs(currentMonthData.expense).toFixed(2) : 0);
            this.currentMonthTotal += currentMonthData.expense ? currentMonthData.expense : 0;
            graphData[0].data.push(currentMonthData.retail ? currentMonthData.retail.toFixed(2) : 0);
            this.currentMonthTotal += currentMonthData.retail ? currentMonthData.retail : 0;
            graphData[0].data.push(currentMonthData.event ? currentMonthData.event.toFixed(2) : 0);
            this.currentMonthTotal += currentMonthData.event ? currentMonthData.event : 0;
            graphData[0].data.push(currentMonthData.membership ? currentMonthData.membership.toFixed(2) : 0);
            this.currentMonthTotal += currentMonthData.membership ? currentMonthData.membership : 0;
            this.currentMonthTotal = parseFloat(this.currentMonthTotal.toFixed(2));
            const vm = this;
            let chartOptions = {
                grid: {
                    show: false
                },
                theme: {
                    mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    },
                    background: 'none'
                },
                plotOptions: {
                    bar: {
                        distributed: true, // this line is mandatory
                        borderRadius: 4,
                        borderRadiusApplication: 'end',
                        barHeight: '90%'
                    }
                },
                colors: [this.themeColor('error'), this.themeColor('graph1'), this.themeColor('graph2'), this.themeColor('secondary')],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return vm.currencySymbol + val.toFixed(2)
                    },
                    style: {
                        fontSize: '11px',
                        fontWeight: 'bold',
                    },
                    offsetY: -20,
                },
                stroke: {
                    show: false
                },
                yaxis: {
                    show: false, // Hides the entire axis (title, line, and labels)
                    labels: {
                        show: false // Specifically ensures the numbers are gone
                    },
                    axisBorder: {
                        show: false // Removes the vertical line on the left
                    },
                    axisTicks: {
                        show: false // Removes the small tick marks
                    }
                },
                xaxis: {
                    categories: categories,
                    show: false,
                    labels: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return vm.currencySymbol + val.toFixed(2);
                        }
                    }
                },
                legend: {
                    show: false
                },
                responsive: [
                    {
                        breakpoint: 600,
                        options: {
                            dataLabels: {
                                enabled: true,
                                formatter: function (val) {
                                    if (val === 0) return '';
                                    return vm.currencySymbol + val.toFixed(0)
                                },
                                style: {
                                    fontSize: '9px',
                                },
                                offsetY: -15,
                            },
                            plotOptions: {
                                bar: {
                                    columnWidth: '70%',
                                }
                            }
                        }
                    }
                ]
            };
            chartOptions.xaxis.categories = categories;
            chartOptions.lastUpdate = currentMonthData.lastUpdate;
            this.chartOptionsIncomeMonthly = chartOptions;
            this.chartDataIncomeMonthly = graphData;
            this.loadingCurrentMonthIncome = false;



            // Build revenue donut chart data as well
            this.buildRevenueDonutChart(currentMonthData);
            // Build expense donut chart data as well
            this.buildExpenseDonutChart(currentMonthData);
        },
        buildRevenueDonutChart(currentMonthData) {
            this.loadingRevenueDonutChart = true;

            // Prepare data for donut chart
            const memberships = currentMonthData.membership || 0;
            const retail = currentMonthData.retail || 0; // One-time purchases
            const events = currentMonthData.event || 0;

            // Calculate total revenue (excluding expenses for revenue breakdown)
            const totalRevenue = memberships + retail + events;

            this.revenueDonutChartData = [memberships, retail, events];

            const vm = this;
            this.revenueDonutChartOptions = {
                chart: {
                    type: 'donut',
                    height: 100,
                    fontFamily: 'Roboto',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%',
                            value: {
                                show: true,
                                fontSize: '24px',
                                fontWeight: 400,
                                color: '#000',
                                formatter: function (val) {
                                    return vm.currencySymbol + parseFloat(val).toFixed(2);
                                }
                                // formatter: function (val) {
                                //     return '<div style="font-size:20px;color:#888;margin-top:60px;">' + val + '</div>';
                                // }
                            },
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    fontfamily: 'Roboto',
                                    color: '#9e9e9e',
                                    formatter: function () {
                                        const val = vm.currencySymbol + totalRevenue.toFixed(2);
                                        return val

                                    }


                                },
                            }
                        }
                    }
                },
                labels: [
                    this.$t('message.transactions_admin_plus.memberships'),
                    this.$t('message.transactions_admin_plus.retail'),
                    this.$t('message.transactions_admin_plus.events')
                ],
                colors: [this.themeColor('secondary'), this.themeColor('orange'), this.themeColor('graph2')],
                legend: {
                    position: 'right',
                    offsetY: 0,
                    height: 350,
                    fontSize: '14px',
                    fontFamily: 'Roboto',
                    itemMargin: {
                        horizontal: 2,
                        vertical: 10
                    },
                    formatter: function (seriesName, opts) {
                        return seriesName + ': ' + vm.currencySymbol + opts.w.globals.series[opts.seriesIndex].toFixed(2);
                    }
                },
                dataLabels: {
                    enabled: false
                },
                responsive: [{
                    breakpoint: 768,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetY: 0,
                            height: 'auto'
                        }
                    }
                }],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return vm.currencySymbol + val.toFixed(2);
                        }
                    }
                }
            };

            this.loadingRevenueDonutChart = false;
        },
        buildExpenseDonutChart(currentMonthData) {
            this.loadingExpenseDonutChart = true;

            // Get expense data by category from expensesGraphs if available
            let expenseCategories = [];
            let expenseValues = [];
            let expenseColors = [];

            // Use existing expense categories and data if available
            if (this.expensesGraphs && this.expensesGraphs.ready && this.expensesGraphs.thisMonth && this.expensesGraphs.thisMonth.data) {
                // Use existing categorized expense data
                const thisMonthData = this.expensesGraphs.thisMonth;
                expenseCategories = (thisMonthData.options.labels || []).map(l => l != null ? String(l) : 'Other');
                expenseValues = (thisMonthData.data || []).map(v => v != null ? Number(v) : 0);

                // Get colors for each category
                for (const category of expenseCategories) {
                    const color = this.expensesGraphs.colors && this.expensesGraphs.colors[category]
                        ? this.expensesGraphs.colors[category]
                        : this.themeColor('error');
                    expenseColors.push(color || '#EF5350');
                }
            } else {
                // Fallback to basic expense data if categorized data not available
                const totalExpense = Math.abs(currentMonthData.expense || 0);
                if (totalExpense > 0) {
                    expenseCategories = ['General Expenses'];
                    expenseValues = [totalExpense];
                    expenseColors = [this.themeColor('error')];
                } else {
                    expenseCategories = ['No Expenses'];
                    expenseValues = [0];
                    expenseColors = ['#E0E0E0'];
                }
            }

            // Calculate total expenses
            const totalExpenses = expenseValues.reduce((sum, value) => sum + value, 0);

            this.expenseDonutChartData = expenseValues;

            const vm = this;
            this.expenseDonutChartOptions = {
                chart: {
                    type: 'donut',
                    height: 350,
                    fontFamily: 'Roboto, sans-serif',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    color: '#9e9e9e',
                                    formatter: function () {
                                        return vm.currencySymbol + totalExpenses.toFixed(2);
                                    }
                                },
                                value: {
                                    show: true,
                                    fontSize: '24px',
                                    fontWeight: 600,
                                    color: '#263238',
                                    formatter: function (val) {
                                        return vm.currencySymbol + parseFloat(val).toFixed(2);
                                    }
                                }
                            }
                        }
                    }
                },
                labels: expenseCategories,
                colors: expenseColors,
                legend: {
                    position: 'right',
                    offsetY: 0,
                    height: 350,
                    fontSize: '14px',
                    fontFamily: 'Roboto, sans-serif',
                    itemMargin: {
                        horizontal: 5,
                        vertical: 3
                    },
                    formatter: function (seriesName, opts) {
                        return seriesName + ': ' + vm.currencySymbol + opts.w.globals.series[opts.seriesIndex].toFixed(2);
                    }
                },
                dataLabels: {
                    enabled: false
                },
                responsive: [{
                    breakpoint: 768,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetY: 0,
                            height: 'auto'
                        }
                    }
                }],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return vm.currencySymbol + val.toFixed(2);
                        }
                    }
                }
            };

            this.loadingExpenseDonutChart = false;
        },
        getCustomers() {
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/customers/credit"
                )
                .then((response) => {
                    this.customers = response.data.customers;
                });
        },
        getAggregates() {
            this.loadingCurrentMonthIncome = true;
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/aggregates/v3?months=2"
                )
                .then((response) => {
                    if (response && response.data.incomeByMonth && Object.keys(response.data.incomeByMonth).length) {
                        const lastKey = Object.keys(response.data.incomeByMonth)[0];
                        const lastValue = response.data.incomeByMonth[lastKey];
                        this.buildCurrentMonthGraph({ month: lastValue });
                        this.loadingCurrentMonthIncome = false;
                    } else {
                        this.loadingCurrentMonthIncome = false;
                    }

                }).catch((err) => {
                    console.log('DEBUG - Error fetching aggregates: ', err);
                })


            this.loadingIncomeTrendline = true;
            Api2()
                .get(
                    "payments/academy/" + this.$store.state.managedAcademy + "/aggregates/v3/trendline?months=12"
                )
                .then((response) => {

                    if (response && response.data.income && response.data.income.length) {
                        this.buildIncomeMonthlyData(response.data.income);
                        this.buildIncomeBars(response.data.income);
                    }
                    this.loadingIncomeTrendline = false;
                });


        },
        showRefundDialog(invoice) {
            this.selectedInvoice = invoice;
            this.refundConfirmDialog = true;
            this.refundAmount = invoice.amountPaid;
        },
        refund() {
            var data = {
                amount: this.refundAmount,
                transaction: this.selectedInvoice.transaction,
            };
            Api()
                .patch(
                    "payments/academy/" +
                    this.$store.state.managedAcademy +
                    "/refund/" +
                    this.selectedInvoice.id,
                    data
                )
                .then((response) => {
                    if (response.data) {
                        this.showAlert("success", this.$t("message.transactions_admin_plus.success"));
                        this.selectedInvoice = null;
                        this.getTransactions();
                        this.refundConfirmDialog = false;
                    }
                })
                .catch((err) => {
                    this.showAlert("error", err.response.data.message);
                });
        },
        filterSubscriptions() {
            this.subscriptionsFiltered = [];
            let val = this.subscriptionsFilter;
            if (!val && !this.stripeReady) {
                this.subscriptionsFilter = 'manual';
                val = 'manual';
            }
            if (val === 'cancelled') {
                const user = (this.subscriptionUserFilter || '').toLowerCase();
                const product = this.subscriptionProductFilter;
                const tag = this.subscriptionTagFilter;
                for (const t of /** @type {any[]} */ (this.cancelledFiltered || [])) {
                    if (user.length > 1 && t.buyer && t.buyer.displayName.toLowerCase().indexOf(user) < 0) continue;
                    if (tag && tag !== '' && (!t.tags || t.tags.indexOf(tag) < 0)) continue;
                    if (product && t.product && t.product._id !== product) continue;
                    if (t.product) {
                        t.productName = t.product.name;
                        t.productInterval = t.product.interval;
                    }
                    this.subscriptionsFiltered.push(t);
                }
                this.totalAmountTitle = this.$t('message.transactions_admin_plus.inactive_memberships');
                this.totalCountTitle = this.$t('message.transactions_admin_plus.inactive_memberships');
                return;
            }
            if (val == 'manual' || val == 'expiring_soon' || val == 'expired') {
                this.totalAmountTitle = this.$t('message.transactions_admin_plus.total_manual_income');
                this.totalCountTitle = this.$t('message.transactions_admin_plus.total_manual_memberships');
            } else {
                this.totalAmountTitle = this.$t('message.transactions_admin_plus.total_recurrent_income');
                this.totalCountTitle = this.$t('message.transactions_admin_plus.total_recurrent_memberships');
            }
            let user = this.subscriptionUserFilter;
            let product = this.subscriptionProductFilter;
            let tag = this.subscriptionTagFilter;
            let totalIncome = 0;
            let trendlineDays = {};
            let membershipCounts = {};
            for (let t of this.subscriptions) {
                t.keep = false;
                if (val) {
                    if (val == "active") {
                        if (t.lastPaymentStatus == "active" && t.product.type != 'good') t.keep = true;
                    } else if (val == "paused") {
                        if (t.lastPaymentStatus == "paused") t.keep = true;
                    } else if (val == "pending") {
                        if (t.lastPaymentStatus == "pending_payment") t.keep = true;
                    } else if (val == "past_due") {
                        if (t.lastPaymentStatus == "past_due" || t.lastPaymentStatus == "unpaid") t.keep = true;
                    } else if (val == "waiting2start") {
                        if (t.lastPaymentStatus == "trialing") t.keep = true;
                    } else if (val == "scheduled_cancellation") {
                        if (t.cancellationDate) t.keep = true;
                    } else if (val == "scheduled_pause") {
                        if (t.pauseDate) t.keep = true;
                    } else if (val == "manual") {
                        if (t.product && t.product.type == 'good') t.keep = true;
                    } else if (val == "expiring_soon") {
                        //End expiring soon
                        if (t.product && t.product.type == 'good' && t.expiringSoon) t.keep = true;
                    } else if (val == "expired") {
                        //End expiring soon
                        if (t.product && t.product.type == 'good' && t.lastPaymentStatus == 'expired') t.keep = true;
                    }
                } else {
                    if (t.product && t.product.type != 'good') t.keep = true;
                }
                if (user && user.length > 1 && t.keep && t.buyer && t.buyer.displayName.toLowerCase().indexOf(user) < 0) {
                    user = user.toLowerCase()
                    t.keep = false;
                }
                if (tag && tag != "" && (!t.tags || t.tags.length == 0 || t.tags.indexOf(tag) < 0)) {
                    t.keep = false;
                }
                if (t.keep && product && t.product && t.product._id != product) {
                    t.keep = false;
                }
                if (t.keep) {
                    if (t.product) {
                        t.productName = t.product.name;
                        t.productInterval = t.product.interval;
                    }
                    this.subscriptionsFiltered.push(t);
                    const interval = t.product ? t.product.interval : null;
                    //Setup trendline data
                    const amount = new Number(this.getMembershipTotal(t)).valueOf();
                    if (interval == 'month') {
                        if (!trendlineDays[t.displayDate]) {
                            trendlineDays[t.displayDate] = 0;
                            membershipCounts[t.displayDate] = 0;
                        }
                        trendlineDays[t.displayDate] += amount;
                        membershipCounts[t.displayDate] += 1;
                    }
                    if (interval == 'bi-week') {
                        //We ned to add 14...
                    }
                    let monthlyAmount = amount;
                    if (interval == 'bi-week')
                        monthlyAmount = amount * 2; //Twice a month
                    else if (interval == 'week')
                        monthlyAmount = amount * 4;
                    else if (interval == 'bi-year')
                        monthlyAmount = amount / 6;
                    else if (interval == 'year')
                        monthlyAmount = amount / 12;
                    else if (interval == 'day')
                        monthlyAmount = amount * 30;
                    else if (!interval && t.product) {
                        const isExpired = t.expired || (t.lastPaymentStatus || '').toLowerCase() === 'expired';
                        if (!isExpired) {
                            if (t.product.membershipMonths > 0)
                                monthlyAmount = amount / t.product.membershipMonths;
                            else if (t.product.membershipDays > 0)
                                monthlyAmount = amount * 30 / t.product.membershipDays;
                            else {
                                // checkin-only: count if sold in the last 30 days
                                const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
                                monthlyAmount = new Date(t.time).getTime() >= thirtyDaysAgo ? amount : 0;
                            }
                        } else {
                            monthlyAmount = 0;
                        }
                    }
                    totalIncome += monthlyAmount;
                }
            }
            let trendlineData = [];
            let hasTrendline = false;
            for (const day of this.membershipsTrendline.categories) {
                if (Object.prototype.hasOwnProperty.call(trendlineDays, day)) {
                    trendlineData.push(trendlineDays[day]);
                    hasTrendline = true;
                } else {
                    trendlineData.push(0);
                }
            }
            //trendlineCagetories
            let vm = this;
            if (hasTrendline) {
                const todayDay = new Date();
                vm.membershipsTrendline.membershipCounts = membershipCounts;
                const currency = vm.currencySymbol;
                vm.membershipsTrendline.data = [{
                    name: vm.$t("message.transactions_admin_plus.memberships"),
                    data: trendlineData
                }];
                vm.membershipsTrendline.options = {
                    labels: [vm.$t("message.transactions_admin_plus.memberships")],
                    colors: [vm.themeColor('primary')],
                    title: {
                        show: true,
                        text: vm.$t("message.transactions_admin_plus.recurrent_payments"),
                        align: 'center',
                    },
                    xaxis: {
                        categories: vm.membershipsTrendline.categories,
                        labels: {
                            show: true,
                        }
                    },
                    yaxis: {
                        labels: {
                            show: true,
                            formatter: function (value) {
                                return currency + value;
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    theme: {
                        mode: this.isDarkMode() ? 'dark' : 'light',
                    },
                    chart: {
                        toolbar: {
                            show: false
                        },
                        background: 'none'
                    },
                    legend: {
                        position: 'top'
                    },
                    grid: {
                        show: false
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, data) {
                                const day = data.dataPointIndex + 1;
                                let count = vm.membershipsTrendline.membershipCounts[day];
                                if (!count)
                                    count = 0;
                                return count + ' ' + vm.$t("message.transactions_admin_plus.memberships") + ' - ' + currency + value;
                            }
                        }, x: {
                            formatter: function (value) {
                                return vm.$t("message.transactions_admin_plus.day_of_month") + ': ' + value;
                            }
                        },
                    },
                    annotations: {
                        xaxis: [
                            {
                                x: todayDay.getDate(),
                                borderColor: vm.themeColor('accent'),
                                label: {
                                    text: 'Today'
                                }
                            }
                        ]
                    }
                };
                this.membershipsTrendline.ready = true;
            }
            this.totalRecurrentIncome = new Number(totalIncome.toFixed(2)).valueOf();
        },
        filterTransactions(filtering) {
            if (!filtering) {
                this.transactionsFiltered = this.transactions;
                this.productFilter = null; // Reset filters if necessary
                this.userFilter = null;
                return;
            }

            this.transactionsFiltered = this.transactions.filter(t => {
                let matchesProduct = true;
                let matchesUser = true;

                // 1. Check Product Filter (Direct product OR within Items array)
                if (this.productFilter) {
                    const hasDirectProduct = t.product && t.product._id === this.productFilter;

                    const hasProductInItems = t.items && t.items.some(item =>
                        item.product && (item.product._id === this.productFilter || item.product === this.productFilter)
                    );

                    matchesProduct = hasDirectProduct || hasProductInItems;
                }

                // 2. Check User Filter
                if (this.userFilter) {
                    matchesUser = t.buyer && t.buyer._id === this.userFilter;
                }

                // 3. Logic: Transaction must satisfy ALL active filters
                return matchesProduct && matchesUser;
            });
        },
        filterExpenses() {
            this.expensesFiltered = [];
            for (var t of this.expenses) {
                if (this.adminFilter) {
                    if (t.user && t.user._id == this.adminFilter) t.keep = true;
                    else t.keep = false;
                }
                if (t.keep) this.expensesFiltered.push(t);
            }
        },
        filterInvoices(csv) {
            this.loadingInvoices = true;
            if (!csv) {
                this.invoices = [];
                this.invoicesTotal = 0;
            }
            if (!this.fromFilter) {
                const d = new Date();
                d.setMonth(d.getMonth() - 1);
                this.fromFilter = d;
            }
            if (!this.toFilter) {
                this.toFilter = new Date();
            }
            const from = this.toBeginningOfDay(this.fromFilter);
            const to = this.toEndOfDay(this.toFilter);
            const filters = {
                from: from,
                to: to,
                customer: this.customerFilter,
                csv: csv,
            };
            Api()
                .post(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/invoices",
                    filters
                )
                .then((response) => {
                    if (csv) {
                        this.showAlert("success", this.$t("message.transactions_admin_plus.report_in_progress", [response.data.sendTo]));
                    } else {
                        this.invoices = response.data.invoices;
                        this.invoicesTotal = response.data.total;
                    }
                    this.loadingInvoices = false;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getTransactions() {
            if (this.activeTab == 1) {
                this.loadRevenue();
            } else if (this.activeTab == 2 && (this.stripeReady || (this.paymentsModule == 'easypay' && this.paymentsReady))) {
                if (this.loadingInvoices)
                    this.filterInvoices(false);
            } else if (this.activeTab == 3) {
                this.getExpenses();
            }
            if (this.activeTab == 0) {
                if (!this.loadingCurrentMonthIncome)
                    this.getAggregates();
                this.triggerStatsRefresh();
                this.loadExpensesCharts(); // Load expense categories for donut chart
            }
        },
        triggerStatsRefresh(force) {
            if (this.triggeringRefresh)
                return;
            this.triggeringRefresh = true;
            let lastMonth = null;
            if (force) {
                lastMonth = new Date();
                lastMonth.setMonth(lastMonth.getMonth() - 1);
            }
            Api2()
                .post(
                    "admins/managedacademy/" +
                    this.$store.state.managedAcademy +
                    "/trigger/monthly/stats", { force: lastMonth }
                ).then(() => {
                    this.triggeringRefresh = false;
                    if (force)
                        this.showAlert("success", this.$t("message.transactions_admin_plus.data_refresh_triggered"));
                });
        },
        getRecurrentTransactions(withFilters) {
            let filters = {};
            if (withFilters) {
                if (this.fromFilter) {
                    if (!this.toFilter)
                        this.toFilter = new Date();
                    this.fromFilter = this.toBeginningOfDay(this.fromFilter);
                    this.toFilter = this.toEndOfDay(this.toFilter);
                    filters = { from: this.fromFilter, to: this.toFilter };
                } else {
                    return;
                }
                this.loadingMembershipsTable = true;
            } else {
                this.fromFilter = null;
                this.toFilter = null
                this.loading = true;
            }
            Api2() /**TODO: make me not depend on stripe ID */
                .post(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/transactions",
                    filters
                )
                .then((response) => {
                    this.loading = false;
                    this.availableTags = response.data.availableTags;
                    let tmp = response.data.subscriptions;
                    let expiring = response.data.expiringSoon;
                    for (let s of tmp) {
                        let sd = new Date(s.time);
                        if (s.billingDate) {
                            sd = new Date(s.billingDate);
                        } else if (s.subscriptionStartDate) {
                            sd = new Date(s.subscriptionStartDate);
                        }
                        s.displayDate = sd.getDate();
                        for (const e of expiring) {
                            if (s._id == e._id) {
                                s.expiringSoon = true;
                                break;
                            }
                        }
                    }
                    this.subscriptions = tmp;
                    if (!this.stripeReady) {
                        this.subscriptionsFilter = "manual";
                    } else {
                        this.filterSubscriptions("active");
                    }
                    this.loadingMembershipsTable = false;
                    this.filterRevenue();
                })
                .catch((e) => {
                    this.loading = false;
                    this.loadingMembershipsTable = false;
                    console.log(e)
                    if (e)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                });
        },
        getExpenses() {
            this.loadingExpenses = true;
            let filters = {};
            if (this.expensesTagFilter)
                filters.tag = this.expensesTagFilter;
            if (this.fromFilter)
                filters.from = this.fromFilter;
            if (this.toFilter)
                filters.to = this.toFilter;
            Api2() /**TODO: make me not depend on stripe ID */
                .post(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/expenses",
                    filters
                )
                .then((response) => {
                    this.loading = false;
                    this.expenses = response.data.expenses;
                    this.colorExpenses();
                    this.expensesFiltered = response.data.expenses;
                    if (response.data.tags)
                        this.expenseTags = response.data.tags;
                    this.loadingExpenses = false;
                })
                .catch((e) => {
                    this.loadingExpenses = false;
                    console.log(e)
                    if (e)
                        this.showAlert("error", this.$t("message.transactions_admin_plus.error_generic"));
                });
        },
        cancelPurchase(id) {
            Api()
                .patch(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/cancel/checkout/" +
                    id
                )
                .then((response) => {
                    if (response) {
                        this.showAlert(
                            "success",
                            this.$t("message.transactions_admin_plus.success"),
                            this.$t("message.transactions_admin_plus.transaction_cancelled")
                        );
                        this.getTransactions();
                    }
                });
        },
        completePurchase(id) {
            Api()
                .patch(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/complete/checkout/" +
                    id
                )
                .then((response) => {
                    if (response) {
                        this.showAlert(
                            "success",
                            this.$t("message.transactions_admin_plus.success"),
                            this.$t("message.transactions_admin_plus.transaction_completed")
                        );
                        this.getTransactions();
                    }
                }).catch((e) => {
                    if (e)
                        this.getTransactions();
                });
        },
        getMembershipTotal(t) {
            if (t.membershipAmount) return Number(t.membershipAmount).toFixed(2);
            let discount = 0;
            if (t.coupon && t.coupon.discountAmount > 0) {
                discount = t.coupon.discountAmount;
            }
            const a = t.product && t.product.amountDecimal ? t.product.amountDecimal : t.amount;
            if (a > 0)
                return (a - discount).toFixed(2);
            else
                return 0;
        },
        checkRedirected() {
            if (this.code && this.state && this.scope) {
                if (this.state == this.stripe_state && this.scope == "read_write") {
                    //console.log('Authenticated, send post to backend to store! ', this.code);
                    Api()
                        .post(
                            "admins/academy/" +
                            this.$store.state.managedAcademy +
                            "/payments/authenticate?code=" +
                            this.code +
                            "&state=" +
                            this.state
                        )
                        .then((response) => {
                            if (response) {
                                this.showAlert("success", this.$t("message.transactions_admin_plus.stripe_connected"));
                                //TODO reload
                                this.$store.dispatch(
                                    "setStripeAccountId",
                                    response.data.stripeAccountId
                                );
                                this.stripeReady = true;
                                this.getTransactions();
                                completeOnboardingStep({
                                    step: "automaticPayments",
                                    managedAcademy: this.$store.state.managedAcademy,
                                    store: this.$store
                                });
                            }
                        });
                }
            }
        },
        connectPayments() {
            const url =
                "https://connect.stripe.com/oauth/authorize?" +
                "client_id=" +
                this.stripe_client_id +
                "&state=" +
                this.stripe_state +
                "&scope=read_write&response_type=code" +
                "&stripe_user[email]=" +
                this.academy.email.toLowerCase().trim() + '&redirect_uri=' + Environment.get("VUE_APP_UI_HOST") + '/secure/plus/transactions-admin';
            window.location = url;
        },
        learnMore() {
            Api()
                .get(
                    "admins/academy/" +
                    this.$store.state.managedAcademy +
                    "/payments/learn_more"
                )
                .then((response) => {
                    this.showAlert(
                        "success",
                        this.$t("message.transactions_admin_plus.thank_you"),
                        this.$t("message.transactions_admin_plus.we_will_contact") + response.data.message
                    );
                })
                .catch((e) => {
                    if (e)
                        this.showAlert("error", "Oops!", this.$t("message.transactions_admin_plus.error_generic"));
                });
        },
        sellItem() {
            this.navigateTo({ name: "bulksell" });
        },
        goToStripeSupport() {
            window.open('https://support.stripe.com/');
        }
    }
};
</script>
